module.exports = __webpack_public_path__ + "static/media/OT-DTE.1a67c22c.png";